import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppWidget from "./WhatsAppWidget";
import { Cpu, Shield, BarChart3, ArrowRight, Zap, Globe, Headphones, Settings } from "lucide-react";
import { Link } from "react-router-dom";

const Machine2MachinePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const solutions = [
    {
      title: "IoT Connectivity",
      description: "Connessione ultra-affidabile per sensori, dispositivi e macchinari industriali con protocolli 4G/5G dedicati.",
      icon: <Cpu className="w-12 h-12 text-orange-500" />,
      features: ["Protocolli Industriali", "Bassa Latenza", "Copertura Globale", "SIM Resistenti"]
    },
    {
      title: "Real-Time Analytics",
      description: "Monitoraggio in tempo reale, analisi predittiva e dashboard personalizzabili per il controllo totale dei processi.",
      icon: <BarChart3 className="w-12 h-12 text-orange-500" />,
      features: ["Dashboard Cloud", "Alert Intelligenti", "Report Dettagliati", "Integrazione API"]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-8 tracking-tighter uppercase">
              L'Industria del <span className="text-orange-500 underline decoration-8">Domani</span>.
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-12 font-medium leading-relaxed">
              Soluzioni M2M e IoT avanzate per la digitalizzazione dei processi produttivi. Connetti, monitora e ottimizza ogni asset della tua azienda.
            </p>
            <div className="flex justify-center">
              <Link to="/preventivo" className="bg-gray-900 text-white px-12 py-6 rounded-2xl font-black text-xl hover:bg-orange-500 transition-all">
                Richiedi Consulenza Tech
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <div className="bg-gray-900 py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { label: "IoT Security", icon: <Shield /> },
              { label: "High Reliability", icon: <Settings /> },
              { label: "Global Roaming", icon: <Globe /> },
              { label: "Instant Data", icon: <Zap /> }
            ].map((item, i) => (
              <div key={i} className="flex flex-col items-center text-center text-white">
                <div className="text-orange-500 mb-4">{item.icon}</div>
                <span className="font-bold text-sm uppercase tracking-widest">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Solutions Grid */}
      <section className="py-32 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
            {solutions.map((solution, index) => (
              <div key={index} className="group">
                <div className="bg-white p-12 rounded-[4rem] border border-gray-100 group-hover:shadow-2xl transition-all duration-700 h-full">
                  <div className="mb-8">{solution.icon}</div>
                  <h3 className="text-4xl font-black text-gray-900 mb-6 tracking-tight uppercase">{solution.title}</h3>
                  <p className="text-xl text-gray-600 mb-10 leading-relaxed">{solution.description}</p>
                  <ul className="space-y-4 mb-12">
                    {solution.features.map((feature, i) => (
                      <li key={i} className="flex items-center space-x-3 text-gray-700 font-bold">
                        <div className="w-2 h-2 bg-orange-500 rounded-full" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/preventivo" className="inline-flex items-center text-orange-500 font-black text-lg uppercase tracking-widest group-hover:translate-x-4 transition-transform">
                    Dettagli Tecnici <ArrowRight className="ml-2" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industrial Banner */}
      <section className="container mx-auto px-4 pb-32">
        <div className="bg-gray-900 rounded-[3rem] p-12 md:p-24 relative overflow-hidden text-white text-center">
          <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center"></div>
          <div className="relative z-10 max-w-3xl mx-auto">
            <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tighter leading-tight uppercase">
              Efficienza in Tempo Reale.
            </h2>
            <p className="text-2xl mb-12 font-bold opacity-90">
              Riduci i fermi macchina e ottimizza i costi operativi con le nostre soluzioni di manutenzione predittiva.
            </p>
            <Link to="/preventivo" className="bg-orange-500 text-white px-12 py-6 rounded-2xl font-black text-xl hover:bg-white hover:text-black transition-all">
              Scarica il White Paper
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppWidget />
    </div>
  );
};

export default Machine2MachinePage;
